import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";
import { API_tecnicos } from "../../config/apiConfig";
import "../../pages/user/css/Perfil.css";

const FormularioCrearTecnico = () => {
  const { token } = useAuth();

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [repiteContrasena, setRepiteContrasena] = useState("");
  const [rol, setRol] = useState("tecnico-1");
  const [estadoEmpleado, setEstadoEmpleado] = useState("Activo");

  // Para mostrar/ocultar contraseña
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const [
    mostrarContrasenaRepetidaTecnico,
    setMostrarContrasenaRepetidaTecnico,
  ] = useState(false);

  // Para manejar estado de envío
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Expresión regular para validar la contraseña
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Comprobamos que todos los campos estén rellenos
    if (
      !nombre ||
      !apellido ||
      !correo ||
      !contrasena ||
      !repiteContrasena ||
      !rol
    ) {
      toast.error("Por favor, rellena todos los campos.");
      return;
    }

    // 2. Comprobamos que la contraseña cumple con los requisitos
    if (!passwordRegex.test(contrasena)) {
      toast.error(
        "La contraseña debe tener mínimo 8 caracteres, incluyendo una mayúscula, una minúscula, un número y un carácter especial."
      );
      return;
    }

    // 3. Comprobamos que ambas contraseñas coincidan
    if (contrasena !== repiteContrasena) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }

    // 4. Crear el técnico
    setIsSubmitting(true);

    try {
      const response = await fetch(API_tecnicos, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify({
          name: nombre,
          lastName: apellido,
          email: correo,
          password: contrasena,
          role: rol,
          employeeStatus: estadoEmpleado,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al crear el técnico");
      }

      const result = await response.json();

      // Éxito: resetear el formulario
      setNombre("");
      setApellido("");
      setCorreo("");
      setContrasena("");
      setRepiteContrasena("");
      setRol("tecnico-1");
      setEstadoEmpleado("Activo");

      toast.success("Técnico creado exitosamente");

      // Recargar la página para actualizar la lista de técnicos
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Error al crear técnico:", error);
      toast.error(error.message || "Error al crear el técnico");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="caja-verde negro">
      <h2 className="blanco align-center mayusculas">
        Crear nuevo usuario con perfil técnico
      </h2>
      <form onSubmit={handleSubmit} className="nuevo-tecnico column">
        <div className="wrap gap-30">
          {/* Nombre */}
          <div className="campo column">
            <label className="verde mayusculas">Nombre *</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Nombre"
              required
              disabled={isSubmitting}
            />
          </div>

          {/* Apellido */}
          <div className="campo column">
            <label className="verde mayusculas">Apellido *</label>
            <input
              type="text"
              value={apellido}
              onChange={(e) => setApellido(e.target.value)}
              placeholder="Apellido"
              required
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="wrap gap-30">
          {/* Email */}
          <div className="campo column correo w-300">
            <label className="verde mayusculas">Correo Electrónico *</label>
            <input
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              placeholder="correoelectronico@gmail.com"
              required
              disabled={isSubmitting}
            />
          </div>

          {/* Rol */}
          <div className="campo column municipio w-200">
            <label className="verde mayusculas">Rol del usuario *</label>
            <select
              required
              value={rol}
              onChange={(e) => setRol(e.target.value)}
              disabled={isSubmitting}
            >
              <option value="tecnico-1">Técnico 1</option>
              <option value="tecnico-2">Técnico 2</option>
              <option value="administrador">Administrador</option>
            </select>
          </div>

          {/* Estado del empleado */}
          <div className="campo column municipio w-200">
            <label className="verde mayusculas">Estado *</label>
            <select
              required
              value={estadoEmpleado}
              onChange={(e) => setEstadoEmpleado(e.target.value)}
              disabled={isSubmitting}
            >
              <option value="Activo">Activo</option>
              <option value="Inactivo">Inactivo</option>
            </select>
          </div>
        </div>

        <div className="wrap gap-30">
          {/* NUEVA CONTRASEÑA */}
          <div className="campo password-group column relative w-250">
            <label className="verde mayusculas">Contraseña *</label>
            <div className="password-field align-center">
              <input
                type={mostrarContrasena ? "text" : "password"}
                value={contrasena}
                onChange={(e) => setContrasena(e.target.value)}
                placeholder="****************"
                required
                disabled={isSubmitting}
              />
              {mostrarContrasena ? (
                <FaEyeSlash
                  className="ojo"
                  onClick={() => setMostrarContrasena(!mostrarContrasena)}
                />
              ) : (
                <FaEye
                  className="ojo"
                  onClick={() => setMostrarContrasena(!mostrarContrasena)}
                />
              )}
            </div>
          </div>

          {/* REPETIR NUEVA CONTRASEÑA */}
          <div className="campo password-group column relative w-250">
            <label className="verde mayusculas">Confirmar Contraseña *</label>
            <div className="password-field align-center">
              <input
                type={mostrarContrasenaRepetidaTecnico ? "text" : "password"}
                value={repiteContrasena}
                onChange={(e) => setRepiteContrasena(e.target.value)}
                placeholder="****************"
                required
                disabled={isSubmitting}
              />
              {mostrarContrasenaRepetidaTecnico ? (
                <FaEyeSlash
                  className="ojo"
                  onClick={() =>
                    setMostrarContrasenaRepetidaTecnico(
                      !mostrarContrasenaRepetidaTecnico
                    )
                  }
                />
              ) : (
                <FaEye
                  className="ojo"
                  onClick={() =>
                    setMostrarContrasenaRepetidaTecnico(
                      !mostrarContrasenaRepetidaTecnico
                    )
                  }
                />
              )}
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="boton negro crear-tecnico"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Creando..." : "Crear nuevo usuario"}
        </button>
      </form>
    </div>
  );
};

export default FormularioCrearTecnico;
